// Constantes numériques
export const FIELD_MAX_LENGTH = 60;
export const RGA_NUMBER = 5;
export const ENCODAGE_NUMBER_MIN_LENGTH = 10;
export const ENCODAGE_NUMBER_MAX_LENGTH = 128;
export const CODE_POSTAL_NUMBER = 5;
export const NUMERO_VOIE_NUMBER = 9;
export const NUMERO_SIA_NUMBER = 12;
export const ADRESSE_INTERNATIONALE_NUMBER = 250;
export const RAISON_SOCIALE_NUMBER = 150;
export const MAX_NAME_LENGTH = 60;
export const MAX_EMAIL_LENGTH = 200;
export const MAX_EMAIL_OBJECT_LENGTH = 255;
export const MAX_EMAIL_CONTENT_LENGTH = 1000;
export const PASSEPORT_CNI = 50;
export const NUMERO_CARCASSE_NUMBER = 100;
export const NUMERO_DEMANDE_RGA_NUMBER = 100;
export const ELEMENT_ARME_NUMBER = 100;
export const TEL_NUMBER = 14;
export const TEL_NUMBER_WITHOUT_SPACE = 10;
export const DUREE_AFFICHAGE_TOASTER = 6000;
export const SIRET_LENGTH_WITH_SPACE = 15;
export const SIRET_LENGTH = 14;
export const villeMaxLength = 60;
export const libVoieMaxLength = 100;
export const lieuDitMaxLength = 60;
export const internationlMaxLength = 255;
export const numeroAgrementMaxLength = 255;
export const numeroAfciMaxLength = 10;

export const REPONSE_MAX_LENGTH = 128;

// Position de la barre des buttons flotante  en pixel
export const BARRE_DEFAULT_BOTTOM = 40;
